module.exports = __webpack_public_path__ + "img/大数据产业协会会员单位.8c4e4ef0.jpg";